import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import styles from './OrderActivitiesLogTable.module.scss';
import { orderEventsTitles } from '../../../constants/orderEvents';
import { datetimeFormatter } from '../../../utils/formatHelper';
import {
  FULFILLMENT_STATE_WAITING_FOR_SHIPPING,
  FULFILLMENT_STATE_COMPLETED,
  FULFILLMENT_STATE_REJECTED,
  FULFILLMENT_STATE_CANCELED,
  ORDER_STATE_VERIFY_SEND_TRACKING_NUMBER,
  ORDER_STATE_COMPLETED,
  ORDER_STATE_CANCELED,
} from '../../../constants/orderStates';

function calculateActivityRows(order) {
  let state;
  const events = [];
  if (order.original_created_at) {
    events.push({
      event: orderEventsTitles.ORDER_CREATED,
      at: order.original_created_at,
    });
  }

  events.push({
    event: orderEventsTitles.ORDER_CAPTURED,
    at: order.created_at,
  });

  order.fulfillments.forEach((fulfillment) => {
    state = fulfillment.states.find((fs) => fs.state === FULFILLMENT_STATE_WAITING_FOR_SHIPPING);
    if (state) {
      events.push({
        event: fulfillment.id_in_source
          ? orderEventsTitles.ORDER_ACCEPTED_WITH_PICK_TICKET + fulfillment.id_in_source
          : orderEventsTitles.ORDER_ACCEPTED,
        at: state.created_at,
      });
    }

    state = fulfillment.states.find((fs) => fs.state === FULFILLMENT_STATE_COMPLETED);
    if (state) {
      events.push({
        event: orderEventsTitles.ORDER_SHIPPED,
        at: state.created_at,
      });
    }

    state = fulfillment.states.find((fs) => fs.state === FULFILLMENT_STATE_REJECTED);
    if (state) {
      events.push({
        event: orderEventsTitles.ORDER_CANCELED,
        at: state.created_at,
      });
    }

    state = fulfillment.states.find((fs) => fs.state === FULFILLMENT_STATE_CANCELED);
    if (state) {
      events.push({
        event: orderEventsTitles.RETAILER_CANCELED,
        at: state.created_at,
      });
    }

    fulfillment.fulfillment_returns.forEach((fulfillmentReturn) => {
      events.push({
        event: orderEventsTitles.FULFILLMENT_RETURN,
        at: fulfillmentReturn.created_at,
      });
    });
  });

  state = order.order_processing_states.find((s) => s.state === ORDER_STATE_VERIFY_SEND_TRACKING_NUMBER);
  if (state) {
    events.push({
      event: orderEventsTitles.TRACKING_SENT,
      at: state.created_at,
    });
  }

  state = order.order_processing_states.find((s) => s.state === ORDER_STATE_COMPLETED);
  if (state) {
    events.push({
      event: orderEventsTitles.ORDER_COMPLETED,
      at: state.created_at,
    });
  }

  state = order.order_processing_states.find((orderState) => orderState.state === ORDER_STATE_CANCELED);
  const isAutoCanceled = state && order.fulfillments.length === 0;

  if (isAutoCanceled) {
    events.push({
      event: orderEventsTitles.ORDER_AUTO_CANCELED,
      at: state.created_at,
    });
  }
  events.sort((a, b) => {
    if (a.at < b.at) {
      return -1;
    } else {
      return 1;
    }
  });

  return events;
}

function OrderActivitiesLogTable(props) {
  if (!props.order) {
    return null;
  }

  const activities = calculateActivityRows(props.order);
  const columns = [
    {
      text: 'Event',
      dataField: 'event',
      align: 'left',
    },
    {
      text: 'Date',
      dataField: 'at',
      formatter: (cell) => datetimeFormatter(cell),
    },
  ];

  return (
    <div className={styles.activityLogWrapper}>
      <hr />
      <h3>Activity Log</h3>

      <BootstrapTable data={activities} columns={columns} keyField="at" striped bordered={false} hover></BootstrapTable>
    </div>
  );
}

export default OrderActivitiesLogTable;
